import { render, staticRenderFns } from "./MediumButton.vue?vue&type=template&id=cc8aca58&"
import script from "./MediumButton.vue?vue&type=script&lang=js&"
export * from "./MediumButton.vue?vue&type=script&lang=js&"
import style0 from "./MediumButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports